import React from 'react'
import Footer from '../../component/Other/Footer'
import Navbar from '../../component/Other/Navbar'
import Discover from '../../component/Page/Discover'
import CoreWorks from '../../component/Page/CoreWorks'
import CardTeam from '../../component/Card/CardTeam'

const Trainers = () => {
    const team = [
        {
            img: "./../images/ur (4).png",
            name: "Keto Glow-Up Full Guide",
            job: " Your Complete Nutrition Journey",
            price: "EGP500",
            btn: "",
            facebook: "#!",
            linkdin: "#!",
            twitter: "#!"
        },
    ]
    return (
        <div className="overflow-hidden">
            <Navbar type={"dark"} />

            <section>
                <div className="container">
                    <div className="text-center mb-5 ">
                        <h2 className='normal font__size--72 text__70-1024 text__70-md text__70-sm text__70-xxs'>
                            <span className="d-block">Unlock Your Health</span>
                            <span className="d-block medium">Transform Your Life</span>
                        </h2>
                        <p className='normal font__size--16 text__16-1024 color__gray-2'>Practical, doctor-approved guidance to help you eat smarter, <br />live healthier, and achieve your body goals — one step at a time.</p>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-xl-10">
                            <div className="row">
                                {
                                    team.map((obj) => {
                                        return <div className="col-md-6 col-lg-4 mb-4">
                                            <CardTeam data={obj} />
                                        </div>
                                    })
                                }

                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <CoreWorks />

            <Discover />

            <Footer />
        </div>
    )
}

export default Trainers